export const getParkReviewsById = (parkReviews, parkId) => parkReviews[parkId];
